var _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnimatedDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 4,
    width: 24,
    viewBox: "0 0 24 4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 2,
    cx: 20,
    opacity: 0.2,
    cy: 2,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1; 0.4; 0.1",
    dur: "1s",
    begin: "-0.8s",
    repeatCount: "indefinite",
    keyTimes: "0;0.75;1",
    keySplines: "1 0 1 0 1 0 1 0",
    calcMode: "spline",
    fill: "#196CA7"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 2,
    cx: 12,
    opacity: 0.2,
    cy: 2,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1; 0.4; 0.1",
    dur: "1s",
    begin: "-1s",
    repeatCount: "indefinite",
    keyTimes: "0;0.75;1",
    keySplines: "1 0 1 0 1 0 1 0",
    calcMode: "spline",
    fill: "#196CA7"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 2,
    cx: 4,
    opacity: 0.2,
    cy: 2,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1; 0.4; 0.1",
    dur: "1s",
    begin: "-0.2s",
    repeatCount: "indefinite",
    keyTimes: "0;0.75;1",
    keySplines: "1 0 1 0 1 0 1 0",
    calcMode: "spline",
    fill: "#196CA7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimatedDots);
export default __webpack_public_path__ + "static/media/animatedDots.e7ed99f8fce663c22fffb4bf2e5fb854.svg";
export { ForwardRef as ReactComponent };